import apiClient from './client';
import type {
  ForecastResponse,
  TrendAnalysisResponse,
  SeasonalityResponse,
  PredictionSummary,
} from '@/types/data';

export interface ForecastParams {
  company_id: number;
  metric?: string;
  training_days?: number;
  forecast_days?: number;
  confidence_level?: number;
  use_cache?: boolean;
}

export interface TrendParams {
  company_id: number;
  metric?: string;
  period_days?: number;
}

export interface SeasonalityParams {
  company_id: number;
  metric?: string;
  period_days?: number;
}

export const predictionApi = {
  // 予測を取得
  getForecast: async (params: ForecastParams): Promise<ForecastResponse> => {
    const response = await apiClient.get<ForecastResponse>('/api/prediction/forecast', { params });
    return response.data;
  },

  // トレンド分析を取得
  getTrend: async (params: TrendParams): Promise<TrendAnalysisResponse> => {
    const response = await apiClient.get<TrendAnalysisResponse>('/api/prediction/trend', { params });
    return response.data;
  },

  // 季節性分析を取得
  getSeasonality: async (params: SeasonalityParams): Promise<SeasonalityResponse> => {
    const response = await apiClient.get<SeasonalityResponse>('/api/prediction/seasonality', { params });
    return response.data;
  },

  // サマリーを取得
  getSummary: async (companyId: number): Promise<PredictionSummary> => {
    const response = await apiClient.get<PredictionSummary>('/api/prediction/summary', {
      params: { company_id: companyId },
    });
    return response.data;
  },
};
